export const routes = data => {
 const [paths, allow] = data;
 const { routes } = paths;
 return [routes, allow];
};

export const categories = (data = [], oldCategories = []) => {
 const compare = (newArr, oldArr) => (JSON.stringify(newArr) !== JSON.stringify(oldArr) ? newArr : false);
 const standardRoutes = data.find(e => e.category === 'COMPANIES' && !e.company)?.routes;
 const categories = compare(
  data.filter(e => e.company),
  oldCategories
 );
 return [standardRoutes, categories];
};
